import {sdkPostMessage} from "../../../util";
import {PostMessageResponse} from "../../../types/sdk-response.interface";

export const account_wisa = {
  /**
   * List accounts
   */
  list(): Promise<PostMessageResponse> {
    return new Promise((resolve, reject) => {
      sdkPostMessage("wisa", "account.list",  undefined)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
